<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-textarea"></require>
  <require from="controls/bs-form-select"></require>

  <as-form-section heading="Basics">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-input type="text" label="Airline Name" placeholder="Airline unique name" value.bind="model.name & validate" disabled.bind="disabled" maxlength="500" hasfocus.bind="autofocus"></bs-form-input>
        </div>
        <div class="col-md-6" if.bind="!model.archivedOn">
          <bs-form-input type="text" label="Airline Code" placeholder="Airline unique code" value.bind="model.code & validate" maxlength="100" disabled.bind="disabled"></bs-form-input>
        </div>
        <div class="col-md-3" if.bind="model.archivedOn">
          <bs-form-input type="text" label="Airline Code" placeholder="Airline unique code" value.bind="model.code & validate" maxlength="100" disabled.bind="disabled"></bs-form-input>
        </div>
        <div class="col-md-3" if.bind="model.archivedOn">
          <bs-form-input type="text" label="Archived by ${model.archivedBy.fullName || model.archivedBy.loginName}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-select label="Airline Rating" placeholder="Select airline's rating" value.bind="model.airlineRating & validate" options.bind="enumService.airlineRatings" matcher.bind="enumsItemMatcher" name-path="name" disabled.bind="disabled"></bs-form-select>
        </div>
        <div class="col-md-6">
          <bs-form-input label="Airline Status" value.bind="model.airlineStatus.name" disabled.bind="true"></bs-form-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <bs-form-textarea label="Comment" placeholder="Optional comment" value.bind="model.comment" disabled.bind="disabled"></bs-form-textarea>
        </div>
      </div>
    </div>
  </as-form-section>
</template>
